import { useNavigate, useLocation } from 'react-router-dom';
import { getRole, logout } from '../auth';
import { colors } from '../theme';

const NAV = {
  super_admin: [
    { path: '/dashboard', label: 'Дашборд' },
    { path: '/applications', label: 'Анкеты' },
    { path: '/matches', label: 'Метчи' },
    { path: '/curators', label: 'Кураторы' },
    { path: '/interview-calendar', label: 'Календарь' },
    { path: '/quiz-questions', label: 'Открытым Текстом' },
    { path: '/broadcasts', label: 'Оповещения' },
    { path: '/packages', label: 'Пакеты искр' },
    { path: '/spark-transactions', label: 'История искр' },
    { path: '/promo-codes', label: 'Промокоды' },
    { path: '/tickets', label: 'Техподдержка' },
    { path: '/photo-requests', label: 'Запросы на замену фото' },
    { path: '/reports', label: 'Жалобы' },
    { path: '/staff-actions', label: 'Журнал персонала' },
    { path: '/settings', label: 'Настройки' },
    { path: '/waitlist', label: 'Лист ожидания (лендинг)' },
  ],
  curator: [
    { path: '/dashboard', label: 'Дашборд' },
    { path: '/clients', label: 'Клиенты' },
    { path: '/matches', label: 'Метчи' },
    { path: '/slots', label: 'Слоты интервью' },
    { path: '/tickets', label: 'Техподдержка' },
    { path: '/photo-requests', label: 'Запросы на замену фото' },
    { path: '/reports', label: 'Жалобы' },
    { path: '/curator-settings', label: 'Настройки' },
  ],
};

export default function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const role = getRole();
  const items = NAV[role] || [];

  return (
    <div style={styles.page}>
      <div style={styles.sidebar}>
        <div style={styles.logo}>ASTRA<span style={styles.logoSub}>{role === 'super_admin' ? 'суперадмин' : 'куратор'}</span></div>
        <nav style={styles.nav}>
          {items.map(item => (
            <div
              key={item.path}
              style={{ ...styles.navItem, ...((location.pathname === item.path || location.pathname.startsWith(item.path + '/')) ? styles.navItemActive : {}) }}
              onClick={() => navigate(item.path)}
            >
              {item.label}
            </div>
          ))}
        </nav>
        <button style={styles.btnLogout} onClick={logout}>Выйти</button>
      </div>
      <div style={styles.content}>{children}</div>
    </div>
  );
}

const styles = {
  page: { display: 'flex', minHeight: '100vh', background: colors.bg, fontFamily: '-apple-system, Segoe UI, sans-serif' },
  sidebar: { width: 220, background: colors.surface, display: 'flex', flexDirection: 'column', padding: '16px 0', flexShrink: 0 },
  logo: { color: colors.accent, fontSize: 18, fontWeight: 700, padding: '0 24px 16px', borderBottom: `1px solid ${colors.border}`, letterSpacing: 1 },
  logoSub: { display: 'block', fontSize: 11, color: colors.textMuted, fontWeight: 400, marginTop: 2, letterSpacing: 0 },
  nav: { display: 'flex', flexDirection: 'column', gap: 1, padding: '10px 10px', flex: 1, overflowY: 'auto' },
  navItem: { padding: '7px 12px', borderRadius: 8, color: colors.textMuted, fontSize: 13, lineHeight: 1.3, cursor: 'pointer' },
  navItemActive: { background: colors.bg, color: colors.accent, fontWeight: 600 },
  btnLogout: { margin: '0 12px', background: 'transparent', border: `1px solid ${colors.border}`, color: colors.textMuted, padding: '8px', borderRadius: 8, cursor: 'pointer', fontSize: 13 },
  content: { flex: 1, padding: 32, overflow: 'auto', color: colors.text },
};
